export default "__VITE_ASSET__55353824__"